import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/create-duck";

const { Types, Creators } = createActions(
  {
    request: ["postData", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "IMPERSONATE_" }
);

export interface ImpersonateState extends IState {}

const INITIAL_STATE: ImpersonateState = {
  data: {},
  loading: false,
  error: null,
};

const request = (state: ImpersonateState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ImpersonateState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ImpersonateState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const impersonate = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ImpersonateTypes = Types;
export const ImpersonateActions = Creators;